import { gql } from "graphql-request";
import { DisconnectNumbersResult } from "~/types";
import { graphqlClient } from "./graphqlClient";

/**
 * Creates a disconnect request for the given phone numbers.
 *
 * Example response:
 *
 *  {
 *    "disconnectNumbers": {
 *      "internalId": "999000279-ORD",
 *      "orderId": "d8e2185e-889e-4640-a6cb-faf2f2c88ff5",
 *      "orderName": "Disconnect order",
 *      "requests": [
 *        {
 *          "disconnectAt": "2026-04-29T23:49:59.000000Z",
 *          "numbers": [
 *            "14013946111"
 *          ],
 *          "requestId": "bbde10ec-9e95-4491-9c1b-5f5881c86f4e",
 *          "requestName": "Delayed disconnect request",
 *          "requestNotes": "Disconnect request delayed due to too recent activation date (90 day disconnect rule)"
 *        }
 *      ]
 *    }
 *  }
 */
export async function disconnectPhoneNumbers(phoneNumbers: string[]) {
  const mutation = gql`
    mutation disconnectNumbersMutation($numbers: [String]) {
      disconnectNumbers(numbers: $numbers) {
        orderId
        orderName
        internalId
        requests {
          requestId
          requestName
          requestNotes
          numbers
          disconnectAt
        }
      }
    }
  `;

  const data = {
    numbers: phoneNumbers,
  };

  try {
    const response: DisconnectNumbersResult = await graphqlClient(
      mutation,
      data
    );

    return response;
  } catch (errorResponse) {
    throw errorResponse;
  }
}
